import { render, staticRenderFns } from "./disease.vue?vue&type=template&id=54985d6d&scoped=true"
import script from "./disease.vue?vue&type=script&lang=js"
export * from "./disease.vue?vue&type=script&lang=js"
import style0 from "./disease.vue?vue&type=style&index=0&id=54985d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54985d6d",
  null
  
)

export default component.exports